import Vue from 'vue'
import Router from 'vue-router'
import TheDashboardPage from '@/components/TheDashboardPage'
import CustomerEdit from '@/components/Admin/Customers/Edit'
import CustomerList from '@/components/Admin/Customers/List'
import CustomerUsers from '@/components/Admin/Users/Users'
import CustomerUser from '@/components/Admin/Users/User'
import CustomerSites from '@/components/Admin/Sites/Sites'
import CustomerSite from '@/components/Admin/Sites/Site'
import Login from '@/components/Login'
import LostPassword from '@/components/LostPassword'
import PasswordReset from '@/components/PasswordReset'
import Import from '@/components/Import/Import'
import ExportData from '@/components/Admin/ExportData/ExportData'
import Indicators from '@/components/Admin/Indicators'
import UserIndicators from '@/components/Charts/Indicators'
import ImportLogs from '@/components/Admin/ImportLogs'
import COSuppliers from '@/components/Admin/COSuppliers'
import Alarms from '@/components/Admin/Alarms'
import Charts from '@/components/Charts/Page'
import Diagnosi from '@/components/Diagnosi/Page'
import SQLConsole from '@/components/Admin/SQL/Index'
import Report from '@/components/Report/Report'
import Reports from '@/components/Reports/Report'
import BlackBoxRules from '@/components/Admin/BlackBox/BlackBoxRules'
import MeasureTypesList from '@/components/Admin/MeasureTypes/MeasureTypesList'
import Logs from '@/components/Admin/Logs/Logs'
import BillAuditList from '@/components/BillAudit/List'
import BillAuditReport from '@/components/BillAudit/Report' 
import store from '@/store/store'

Vue.use(Router)

let router = new Router({
  linkActiveClass: 'active',
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/lost-password',
      name: 'LostPassword',
      component: LostPassword
    },
    {
      path: '/password-reset',
      name: 'PasswordReset',
      component: PasswordReset
    },
    {
      path: '/',
      name: 'Dashboard',
      component: TheDashboardPage,
      meta: { requiresAuth: true }
    },
    {
      path: '/sql',
      name: 'SQL',
      component: SQLConsole,
      meta: { requiresAuth: true }
    },
    {
      path: '/print-reports/:id/:month',
      name: 'print-report',
      component: Reports,
      meta: { requiresAuth: true }
    },
    {
      path: '/print-reports/:id',
      name: 'print-report',
      component: Reports,
      meta: { requiresAuth: true }
    },
    {
      path: '/report',
      name: 'Report',
      component: Report,
      meta: { requiresAuth: true }
    },
    {
      path: '/reports/',
      name: 'ReportSection',
      component: Reports,
      meta: { requiresAuth: true }
    },
    {
      path: '/reports/:id',
      name: 'ReportSection',
      component: Reports,
      meta: { requiresAuth: true }
    },
    {
      path: '/blackbox/rules',
      name: 'BlackBox',
      component: BlackBoxRules,
      meta: { requiresAuth: true }
    },
    {
      path: '/customers',
      name: 'Customers',
      component: CustomerList,
      meta: { requiresAuth: true }
    },
    {
      path: '/customers/new',
      name: 'CustomerNew',
      component: CustomerEdit,
      props: {
        currentPage: 'customerEdit',
        isNew: true
      },
      meta: { requiresAuth: true }
    },
    {
      path: '/customers/:guid',
      name: 'Customer',
      props: {
        currentPage: 'view'
      },
      component: CustomerEdit,
      meta: { requiresAuth: true }
    },
    {
      path: '/customers/:guid/edit',
      name: 'CustomerEdit',
      props: {
        currentPage: 'customerEdit'
      },
      component: CustomerEdit,
      meta: { requiresAuth: true }
    },
    {
      path: '/users',
      name: 'CustomerUsers',
      component: CustomerUsers,
      meta: { requiresAuth: true }
    },
    {
      path: '/users/new',
      name: 'CustomerUsersNew',
      component: CustomerUser,
      props: {
        reset: true
      },
      meta: { requiresAuth: true }
    },
    {
      path: '/users/:guid',
      name: 'CustomerUsersEdit',
      component: CustomerUser,
      meta: { requiresAuth: true }
    },
    {
      path: '/sites',
      name: 'CustomerSites',
      component: CustomerSites,
      meta: { requiresAuth: true }
    },
    {
      path: '/sites/new',
      name: 'CustomerSite',
      component: CustomerSite,
      meta: { requiresAuth: true }
    },
    {
      path: '/sites/:guid',
      name: 'CustomerSiteEdit',
      component: CustomerSite,
      meta: { requiresAuth: true }
    },
    {
      path: '/upload',
      name: 'Import',
      component: Import,
      meta: { requiresAuth: true }
    },
    {
      path: '/indicators',
      name: 'Indicators',
      component: Indicators,
      meta: { requiresAuth: true }
    },
    {
      path: '/chart/indicators',
      name: 'User indicators',
      component: UserIndicators,
      meta: { requiresAuth: true, indicators: true }
    },
    {
      path: '/charts',
      name: 'Charts',
      component: Charts,
      meta: { requiresAuth: true }
    },
    {
      path: '/charts/:id',
      name: 'UserChart',
      component: Charts,
      meta: { requiresAuth: true }
    },
    {
      path: '/diagnosi-energetica',
      name: 'Diagnosi',
      component: Diagnosi,
      meta: { requiresAuth: true }
    },
    {
      path: '/logs',
      name: 'Logs',
      component: Logs,
      meta: { requiresAuth: true }
    },
    /*{
      path: '/comingsoon1',
      name: 'Coming soon',
      component: ComingSoon,
      meta: { requiresAuth: true }
    },
    {
      path: '/comingsoon2',
      name: 'Coming soon',
      component: ComingSoon,
      meta: { requiresAuth: true }
    },
    {
      path: '/comingsoon3',
      name: 'Coming soon',
      component: ComingSoon,
      meta: { requiresAuth: true }
    },*/
    {
      path: '/export-data',
      name: 'Export-data',
      component: ExportData,
      meta: { requiresAuth: true }
    },
    {
      path: '/import-logs',
      name: 'Import-logs',
      component: ImportLogs,
      meta: { requiresAuth: true }
    },
    {
      path: '/co-suppliers',
      name: 'CO-Suppliers',
      component: COSuppliers,
      meta: { requiresAuth: true }
    },
    {
      path: '/alarms',
      name: 'Alarms',
      component: Alarms,
      meta: { requiresAuth: true }
    },
    {
      path: '/measure-types',
      name: 'MeasureTypesList',
      component: MeasureTypesList,
      meta: { requiresAuth: true }
    },
    {
      path: '/bill-audit/list',
      name: 'BillAuditList',
      component: BillAuditList,
      meta: { requiresAuth: true }
    },
    {
      path: '/bill-audit/view/:id',
      name: 'BillAuditReport',
      component: BillAuditReport,
      meta: { requiresAuth: true }
    }
  ]
})

router.beforeEach((to, from, next) => {
  store.commit("setPrintLayout", to.name == "print-report");

  if(to.matched.some(record => record.path == '/login')) {
    if (!!store.state.isLoggedIn) {
      next('/');
    }
  }
  if(to.matched.some(record => record.meta.requiresAuth)) {
    if (!!store.state.isLoggedIn) {
      store.commit("loading");
      store.dispatch("loadUser").then(function () {
        store.commit("stopLoading");
        next();
      })
      return;
    }

    store.commit("LOGOUT");
    next('/login');
  } else {
    next();
  }
})

router.afterEach((to, from) => {
  store.commit("closeMenu");
})

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js